import * as React from 'react'

import NumberFormat from 'react-number-format';

type Props = {
    onValueChange: (newValue: number) => void,
    value: number,
    suffix?: string
    isEdit?: boolean,
    onEnter?: () => void,
    prefix?: string,
    autoFocus?: boolean
  }
  

const FilterNumberInput: React.FC<Props> = ({autoFocus=false, onValueChange, value, prefix='', suffix='', isEdit=false, onEnter=()=>undefined}: Props) => {
    const [displayValue, setDisplayValue] = React.useState<string>(value.toString());
    
    function tryCommitChange() {
        let parsedValue = +displayValue;
        
        if(isNaN(parsedValue)) {
            parsedValue = 0;
        }
        const hasChanged = value !== parsedValue;
        if (hasChanged) {
            
            onValueChange(parsedValue);
        }
    }

    const _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          onEnter();
        }
      }

    React.useEffect(() => {
        if (!isEdit) {
            setDisplayValue(value.toString());
        }
    }, [value, isEdit]);

    React.useEffect(() => {
        tryCommitChange();
    }, [displayValue]);

    return (
        <div className="inline-block py-1">
            {isEdit &&
            <span style={{paddingRight: '3px'}}>
                {prefix}
                <input
                autoFocus={autoFocus}
                onKeyDown={_handleKeyDown}
                className="text-black px-1 outline-none border-b-2 border-gray-300" 
                value={displayValue} 
                style={{ 
                    width: displayValue.toString().length + 1.3 + 'ch',
                }}  
                type="number" 
                onChange={(e) => {
                    setDisplayValue(e.target.value);
                }}
                />
                {suffix}
            </span>
            }
            {!isEdit && 
                <div
                className="inline-block text-gray-900 font-medium rounded px-1 cursor-pointer ">
                    <NumberFormat value={value} prefix={prefix + ' '} thousandSeparator={true} displayType={'text'} /> {suffix}
                    </ div>
            }
        </div>
        
    );
}

export default FilterNumberInput;



